import React from 'react';
import { Snackbar } from '@mui/material';
import { useEditProductForm } from './edit-product-form/useEditProductForm';
import { FormHeader } from './edit-product-form/components/FormHeader';
import { ProductDetailsSection } from './edit-product-form/components/ProductDetailsSection';
import { PricingSection } from './edit-product-form/components/PricingSection';
import { ClassificationSection } from './edit-product-form/components/ClassificationSection';
import { MediaSection } from './edit-product-form/components/MediaSection';
import { PromotionsSection } from './edit-product-form/components/PromotionsSection';
import { ToppingsSection } from './edit-product-form/components/ToppingsSection';
import { IngredientsSection } from './edit-product-form/components/IngredientsSection';
import { ActionFooter } from './edit-product-form/components/ActionFooter';
import { StatusUpdateSection } from './edit-product-form/components/StatusUpdateSection';
import ErrorFormAlert from './ErrorForm';
import styles from './edit-product-form/components/styles.module.css';

const EditProductForm = ({ product, onClose, onUpdate, onRefresh }) => {
  const form = useEditProductForm({ product, onUpdate, onClose });

  return (
    <div ref={form.formTopRef} className={styles.formWrapper}>
      <FormHeader
        product={product}
        productType={form.productType}
        changedCount={form.changedCount}
        onClose={onClose}
      />

      <div className={styles.formBody}>
        {form.missingFields.length > 0 && (
          <div className={styles.errorWrapper}>
            <ErrorFormAlert data={form.missingFields} fullWidth />
          </div>
        )}

        <ProductDetailsSection
          productName={form.productName}
          setProductName={form.setProductName}
          recipeWith={form.recipeWith}
          setRecipeWith={form.setRecipeWith}
          description={form.description}
          setDescription={form.setDescription}
          selectedDays={form.selectedDays}
          setSelectedDays={form.setSelectedDays}
          errors={form.errors}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          onChangeHandler={form.onChangeHandler}
        />

        <PricingSection
          price={form.price}
          setPrice={form.setPrice}
          quantity={form.quantity}
          setQuantity={form.setQuantity}
          servingTemperature={form.servingTemperature}
          setServingTemperature={form.setServingTemperature}
          productType={form.productType}
          productCategory={form.productCategory}
          errors={form.errors}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          onChangeHandler={form.onChangeHandler}
          trackField={form.trackField}
        />

        <ClassificationSection
          productCategory={form.productCategory}
          setProductCategory={form.setProductCategory}
          specialMarking={form.specialMarking}
          setSpecialMarking={form.setSpecialMarking}
          cuisineType={form.cuisineType}
          setCuisineType={form.setCuisineType}
          size={form.size}
          setSize={form.setSize}
          categoryList={form.categoryList}
          editingFields={form.editingFields}
          startEdit={form.startEdit}
          cancelField={form.cancelField}
          trackField={form.trackField}
        />

        <MediaSection
          imageFile={form.imageFile}
          setImageFile={form.setImageFile}
          previewUrl={form.previewUrl}
          setPreviewUrl={form.setPreviewUrl}
          ingredientImageFile={form.ingredientImageFile}
          setIngredientImageFile={form.setIngredientImageFile}
          ingredientPreviewUrl={form.ingredientPreviewUrl}
          setIngredientPreviewUrl={form.setIngredientPreviewUrl}
        />

        {form.productType === 'non_meal_item' && (
          <PromotionsSection offers={form.offers} setOffers={form.setOffers} />
        )}

        {form.productType === 'non_meal_item' && (
          <ToppingsSection
            extraToppings={form.extraToppings}
            setExtraToppings={form.setExtraToppings}
          />
        )}

        <IngredientsSection
          ingredients={form.ingredients}
          setIngredients={form.setIngredients}
          allergicIngredients={form.allergicIngredients}
          setAllergicIngredients={form.setAllergicIngredients}
        />

        <ActionFooter
          editConfirmed={form.editConfirmed}
          setEditConfirmed={form.setEditConfirmed}
          fieldsToBeUpdatedUnique={form.fieldsToBeUpdatedUnique}
          isLoading={form.isLoading}
          onClose={onClose}
          handleUpdateProduct={form.handleUpdateProduct}
        />

        <StatusUpdateSection onRefresh={onRefresh} onClose={onClose} product={product} />
      </div>

      <Snackbar
        open={form.openSnackBar}
        autoHideDuration={5000}
        onClose={() => form.setOpenSnackBar(false)}
        message='Product updated successfully!'
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        className='order-snackbar'
      />
    </div>
  );
};

export default EditProductForm;
